import React from "react";
import "./styles.css";
import { Progress } from "antd";
import { colors } from "../../theme/colors";
import Text from "../typography/text";
import PaymentIcon from "../../icons/payment-icon";
import { formatNumber } from "../card";

const CircularProgress = ({
  commissionAppliedTillDate,
  commissionableSale,
  commissionRate,
  remainingBalance,
  commissionReceived,
  commissionReceivable,
}) => {
  const percent = (commissionAppliedTillDate / commissionableSale) * 100;
  const [whole, decimal] = formatNumber(commissionableSale).split(".");
  const [whole2, decimal2] = formatNumber(commissionAppliedTillDate).split(".");
  const [whole3, decimal3] = formatNumber(remainingBalance).split(".");
  const [whole4, decimal4] = formatNumber(commissionReceived).split(".");
  const [whole5, decimal5] = formatNumber(commissionReceivable).split(".");
  //   const [whole2, decimal2] = formatNumber(commissionRate).split(".");

  return (
    <div className="circular-progress-container">
      <div className="circular-progress-child-container">
        {/* <div className="circular-chart">
          <div  className="total-circular-chart"></div>
          <div className="progress-circular-chart"></div>
        </div> */}
        <Progress
          type="circle"
          percent={percent}
          strokeColor={colors["successColor"]}
          trailColor={colors["blueBackground"]}
          format={(percent) => {
            return (
              <div className="content-circular-container">
                <Text variant="numberBig">{percent.toFixed(0)}%</Text>
                <Text variant="tinyText">Commission Progress</Text>
              </div>
            );
          }}
          size={350}
          strokeLinecap="square"
          strokeWidth={11}
        />
      </div>
      <div className="circular-progress-content-container">
        <div className="circular-progress-content-container-child">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Commissionable Sale
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal}
            </Text>
          </Text>
          <Text variant="tinyText" color="lightText">
            Sum of all commissionable products
          </Text>
        </div>
        <div className="circular-progress-content-container-child">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Commissionable Rate
            </Text>
          </div>
          <Text variant="numberBig">{commissionRate}%</Text>
          <Text variant="tinyText" color="lightText">
            Manufacturer’s commission rate for this invoice
          </Text>
        </div>
      </div>
      <div className="circular-progress-content-container">
        <div className="circular-progress-content-container-child">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Commission Applied Till Date
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole2}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal2}
            </Text>
          </Text>
          <Text variant="tinyText" color="lightText">
            Sum of applied commissions to products
          </Text>
        </div>
        <div className="circular-progress-content-container-child">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Remaining Balance
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole3}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal3}
            </Text>
          </Text>
          <Text variant="tinyText" color="lightText">
            Remaining balance to be applied
          </Text>
        </div>
      </div>
      <div className="circular-progress-content-container">
        <div className="circular-progress-content-container-child">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Commission Recieved Till Date
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole4}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal4}
            </Text>
          </Text>
          <Text variant="tinyText" color="lightText">
            Commission received based on commission applied
          </Text>
        </div>
        <div className="circular-progress-content-container-child">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Commission Receivable
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole5}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal5}
            </Text>
          </Text>
          <Text variant="tinyText" color="lightText">
            Commission receivable when invoice is paid in full
          </Text>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
